import React from 'react';

import { SpaceWrapper }from './styles';

function Space() {
    return(
        <SpaceWrapper />
    );
}

export default Space;